import { canvasUtils } from "@pixi/canvas-renderer";
import { NineSlicePlane } from "@pixi/mesh-extras";
NineSlicePlane.prototype._cachedTint = 16777215;
NineSlicePlane.prototype._tintedCanvas = null;
NineSlicePlane.prototype._canvasUvs = null;
NineSlicePlane.prototype._renderCanvas = function(renderer) {
  const context = renderer.canvasContext.activeContext, transform = this.worldTransform, isTinted = this.tintValue !== 16777215, texture = this.texture;
  if (!texture.valid)
    return;
  isTinted && this._cachedTint !== this.tintValue && (this._cachedTint = this.tintValue, this._tintedCanvas = canvasUtils.getTintedCanvas(this, this.tintValue));
  const textureSource = isTinted ? this._tintedCanvas : texture.baseTexture.getDrawableSource();
  this._canvasUvs || (this._canvasUvs = [0, 0, 0, 0, 0, 0, 0, 0]);
  const vertices = this.vertices, uvs = this._canvasUvs, u0 = isTinted ? 0 : texture.frame.x, v0 = isTinted ? 0 : texture.frame.y, u1 = u0 + texture.frame.width, v1 = v0 + texture.frame.height;
  uvs[0] = u0, uvs[1] = u0 + this._leftWidth, uvs[2] = u1 - this._rightWidth, uvs[3] = u1, uvs[4] = v0, uvs[5] = v0 + this._topHeight, uvs[6] = v1 - this._bottomHeight, uvs[7] = v1;
  for (let i = 0; i < 8; i++)
    uvs[i] *= texture.baseTexture.resolution;
  context.globalAlpha = this.worldAlpha, renderer.canvasContext.setBlendMode(this.blendMode), renderer.canvasContext.setContextTransform(transform, this.roundPixels);
  for (let row = 0; row < 3; row++)
    for (let col = 0; col < 3; col++) {
      const ind = col * 2 + row * 8, sw = Math.max(1, uvs[col + 1] - uvs[col]), sh = Math.max(1, uvs[row + 5] - uvs[row + 4]), dw = Math.max(1, vertices[ind + 10] - vertices[ind]), dh = Math.max(1, vertices[ind + 11] - vertices[ind + 1]);
      context.drawImage(
        textureSource,
        uvs[col],
        uvs[row + 4],
        sw,
        sh,
        vertices[ind],
        vertices[ind + 1],
        dw,
        dh
      );
    }
};
//# sourceMappingURL=NineSlicePlane.mjs.map
